var map = {
	"./card_bg_1.png": 753,
	"./card_bg_10.png": 754,
	"./card_bg_11.png": 755,
	"./card_bg_12.png": 756,
	"./card_bg_2.png": 757,
	"./card_bg_3.png": 758,
	"./card_bg_4.png": 759,
	"./card_bg_5.png": 760,
	"./card_bg_6.png": 761,
	"./card_bg_7.png": 762,
	"./card_bg_8.png": 763,
	"./card_bg_9.png": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;